// Build-time feature flags (set via env var REACT_APP_ALLOW_PAID_EVENTS="true" to allow paid events)
export const ALLOW_PAID_EVENTS = (process.env.REACT_APP_ALLOW_PAID_EVENTS === 'true');

// Default: feature disabled unless explicitly enabled in environment.
export default {
  ALLOW_PAID_EVENTS
};
